import React, { Component } from 'react';
import CheckBox from './../../../../../components/ZUILib/CheckBox';

export default class GiftDeliveryPreferences extends Component {
  render() {
    return (
      <div className="col-sm-4 giftPA">
        <h3 className="giftPAName">{this.props.addresses.displayName}</h3>
        <span className="giftPAAdmin">{this.props.addresses.addressTitle}</span>
        <address>Mario Pani, Ext. 200, Int. s/n Contadero, Santa Fe, Álvaro Obregón, C.P. 12312, México, Ciudad de México</address>
        <div className="days"><span>Días disponibles para entrega</span>
          <ul className="selectDayList">
            <form>
              <li>
                {this.props.addresses.checkBoxData.map((currentAddress, index) => <CheckBox key={currentAddress.id + index} id={currentAddress.id} checked={currentAddress.checked} value={currentAddress.id} displayName={currentAddress.displayName} disabled={currentAddress.disabled} />)}
              </li>
            </form>
          </ul>
        </div>
      </div>
    );
  }
}
